import React from 'react'
import { AppProps } from 'next/app'

import ErrorBoundary from 'src/components/ErrorBoundary'

import 'src/styles/globals.css'

if (process.env.NEXT_PUBLIC_API_MOCKING === 'enabled') {
  import('../../mocks')
}

const MyApp: React.FC<AppProps> = ({ Component, pageProps }) => {
  return (
    <ErrorBoundary>
      <Component {...pageProps} />
    </ErrorBoundary>
  )
}

export default MyApp
